import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.3998 2.39961C5.95798 2.39961 5.5998 2.75779 5.5998 3.19961V3.59961C5.5998 3.82052 5.42072 3.99961 5.1998 3.99961C4.97889 3.99961 4.7998 3.82052 4.7998 3.59961V3.19961C4.7998 2.31595 5.51615 1.59961 6.3998 1.59961H6.7998C7.02072 1.59961 7.1998 1.7787 7.1998 1.99961C7.1998 2.22052 7.02072 2.39961 6.7998 2.39961H6.3998Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5998 9.5998C5.5998 10.0416 5.95798 10.3998 6.3998 10.3998H6.7998C7.02072 10.3998 7.1998 10.5789 7.1998 10.7998C7.1998 11.0207 7.02072 11.1998 6.7998 11.1998H6.3998C5.51615 11.1998 4.7998 10.4835 4.7998 9.5998V9.1998C4.7998 8.97892 4.97889 8.7998 5.1998 8.7998C5.42072 8.7998 5.5998 8.97892 5.5998 9.1998V9.5998Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5998 5.1998C5.5998 4.97889 5.42072 4.7998 5.1998 4.7998C4.97889 4.7998 4.7998 4.97889 4.7998 5.1998V7.5998C4.7998 7.82072 4.97889 7.9998 5.1998 7.9998C5.42072 7.9998 5.5998 7.82072 5.5998 7.5998V5.1998Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8 2.39961C13.2418 2.39961 13.6 2.75779 13.6 3.19961V3.59961C13.6 3.82052 13.7791 3.99961 14 3.99961C14.2209 3.99961 14.4 3.82052 14.4 3.59961V3.19961C14.4 2.31595 13.6837 1.59961 12.8 1.59961H12.4C12.1791 1.59961 12 1.7787 12 1.99961C12 2.22052 12.1791 2.39961 12.4 2.39961H12.8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8 10.3998C13.2418 10.3998 13.6 10.0416 13.6 9.5998V9.1998C13.6 8.97892 13.7791 8.7998 14 8.7998C14.2209 8.7998 14.4 8.97892 14.4 9.1998V9.5998C14.4 10.4835 13.6837 11.1998 12.8 11.1998H12.4C12.1791 11.1998 12 11.0207 12 10.7998C12 10.5789 12.1791 10.3998 12.4 10.3998H12.8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0001 4.7998C13.7792 4.7998 13.6001 4.97889 13.6001 5.1998V7.5998C13.6001 7.82072 13.7792 7.9998 14.0001 7.9998C14.221 7.9998 14.4001 7.82072 14.4001 7.5998V5.1998C14.4001 4.97889 14.221 4.7998 14.0001 4.7998Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.4 1.59961C8.17912 1.59961 8 1.7787 8 1.99961C8 2.22052 8.17912 2.39961 8.4 2.39961H10.8C11.0209 2.39961 11.2 2.22052 11.2 1.99961C11.2 1.7787 11.0209 1.59961 10.8 1.59961H8.4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 10.8004C8 10.5795 8.17912 10.4004 8.4 10.4004H10.8C11.0209 10.4004 11.2 10.5795 11.2 10.8004C11.2 11.0213 11.0209 11.2004 10.8 11.2004H8.4C8.17912 11.2004 8 11.0213 8 10.8004Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.2001 4.7998H4.0001V9.9998C4.0001 11.1044 4.89553 11.9998 6.0001 11.9998H11.2001V12.7998C11.2001 13.6835 10.4838 14.3998 9.6001 14.3998H4.4001C2.8537 14.3998 1.6001 13.1462 1.6001 11.5998V6.3998C1.6001 5.51615 2.31644 4.7998 3.2001 4.7998Z",
			fill: "currentColor"
		})
	]
});
export default SvgCopy;
